module.exports = __webpack_public_path__ + "static/media/blank-slate.f0cf3b73.png";